<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  (closed)="close()"
  title="Edit Project"
  size="md"
>
  <form class="space-y-4" [formGroup]="editForm" (ngSubmit)="save()">
    <div>
      <label for="projectTitle" class="mb-1 block text-sm font-medium text-gray-700"
        >Project Title</label
      >
      <input
        id="projectTitle"
        type="text"
        formControlName="title"
        maxlength="255"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
        placeholder="Enter project title"
      />
      @if (submitted && editForm.controls.title.errors?.required) {
        <small class="text-sm text-red-600">Project title is required.</small>
      }
      @if (submitted && editForm.controls.title.errors?.minlength) {
        <small class="text-sm text-red-600"
          >Project title must be at least 3 characters long.</small
        >
      }
      @if (submitted && editForm.controls.title.errors?.maxlength) {
        <small class="text-sm text-red-600"
          >Project title must be at most 255 characters long.</small
        >
      }
    </div>

    <div>
      <label for="projectDescription" class="mb-1 block text-sm font-medium text-gray-700"
        >Description</label
      >
      <textarea
        id="projectDescription"
        formControlName="description"
        rows="4"
        maxlength="1000"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary h-48"
        placeholder="Enter project description (optional)"
      ></textarea>
      @if (submitted && editForm.controls.description.errors?.maxlength) {
        <small class="text-sm text-red-600 block mt-1"
          >Description must be at most 1000 characters long.</small
        >
      }
      <p class="mt-1 text-xs text-gray-500">
        Provide a brief description of your project and its goals.
      </p>
    </div>

    @if (errorMessage) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="flex items-center justify-between gap-2 pt-2">
      <button
        type="button"
        class="rounded-lg border border-red-200 bg-white px-4 py-2 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
        (click)="askDelete()"
        [disabled]="saving || deleting"
      >
        Delete
      </button>

      <div class="flex justify-end gap-2">
        <button
          type="button"
          class="rounded-lg bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-70"
          (click)="close()"
          [disabled]="saving || deleting"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover disabled:cursor-not-allowed disabled:opacity-70"
          [disabled]="saving || deleting"
        >
          {{ saving ? 'Saving...' : 'Save changes' }}
        </button>
      </div>
    </div>
  </form>

  <app-confirm-modal
    [open]="showDeleteConfirm"
    [title]="'Delete project'"
    [message]="deleteConfirmMessage"
    [confirmText]="'Delete project'"
    [cancelText]="'Keep project'"
    [confirmVariant]="'danger'"
    [loading]="deleting"
    size="sm"
    (openChange)="showDeleteConfirm = $event"
    (confirmed)="confirmDelete()"
    (canceled)="cancelDelete()"
  ></app-confirm-modal>
</app-base-modal>
